import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { calculateRem } from '@uie/javascript-style-helpers';
import RadioBox from './RadioBox';
import { calculateSpacing } from '@vds-core/theme';
var propTypes = {
  /**
   * An object containing number of RadioBox components per row, in each viewport
   */
  count: PropTypes.number,

  /**
   * @ignore
   */
  index: PropTypes.number,

  /**
   * @ignore
   */
  rowQuantity: PropTypes.number
};
var defaultProps = {
  rowQuantity: 3
};
var GAP = '3X';

var createPaddingStyles = function createPaddingStyles(props) {
  var count = props.count,
      index = props.index,
      rowQuantity = props.rowQuantity;
  var paddingRight = GAP;
  var num = (index + 1) / rowQuantity;

  if (num !== 0 && Number.isInteger(num)) {
    paddingRight = 0;
  }

  var paddingStyles = "\n    padding: 0 ".concat(paddingRight !== 0 ? calculateSpacing(paddingRight, 'rem') : 0, " ").concat(calculateSpacing(GAP, 'rem'), " 0;\n  ");
  return paddingStyles;
};

var calculateWidth = function calculateWidth(props) {
  var index = props.index,
      rowQuantity = props.rowQuantity,
      width = props.width,
      flexBasis = props.flexBasis;
  var newWidth,
      paddingRight = GAP,
      difference = "calc(".concat(calculateSpacing(paddingRight), "/").concat(rowQuantity, ")");

  if (width === '100%') {
    if ((index + 1) % rowQuantity === 0) {
      newWidth = "\n      width: calc((".concat(flexBasis, " - ").concat(calculateSpacing(paddingRight), ") + ").concat(difference, ");\n      max-width: calc((").concat(flexBasis, " - ").concat(calculateSpacing(paddingRight), ") + ").concat(difference, ");\n      ");
    } else {
      newWidth = "\n      width: calc(".concat(flexBasis, " + ").concat(difference, ");\n      max-width: calc(").concat(flexBasis, " + ").concat(difference, ");\n      ");
    }
  } else if ((index + 1) % rowQuantity === 0) {
    newWidth = "\n    width: calc(auto - ".concat(calculateSpacing(paddingRight), ");\n    max-width: ").concat(flexBasis, ";\n    ");
  } else {
    newWidth = "\n    width: auto;\n    max-width: ".concat(flexBasis, ";\n    ");
  }

  return newWidth;
};

var findWidth = function findWidth(width) {
  if (typeof width === 'string') return width;
  return calculateRem(width);
};

var RadioBoxWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "RadioBoxWrapper",
  componentId: "sc-8podm4-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  flex-shrink: 1;\n  outline: none;\n  ", ";\n  ", ";\n"])), function (props) {
  return createPaddingStyles(props);
}, function (props) {
  return calculateWidth(props);
});

var RadioBoxGroupItem = function RadioBoxGroupItem(props) {
  var count = props.count,
      index = props.index,
      rowQuantity = props.rowQuantity,
      width = props.width,
      margin = props.margin;
  return /*#__PURE__*/React.createElement(RadioBoxWrapper, {
    count: count,
    index: index,
    rowQuantity: rowQuantity,
    flexBasis: 100 / rowQuantity + '%',
    width: width
  }, /*#__PURE__*/React.createElement(RadioBox, props));
};

RadioBoxGroupItem.propTypes = propTypes;
RadioBoxGroupItem.defaultProps = defaultProps;
export default RadioBoxGroupItem;